package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.ButtonStyle
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import ir.hosen.resume.util.bps
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img

private val SCREEN_ID = ScreenItem.Home.id

@Composable
fun HomeScreen() {
    Box(
        modifier = Modifier.id(SCREEN_ID).fillMaxWidth().height(100.vh).background(Theme.backgroundColor),
        contentAlignment = Alignment.Center
    ) {
        Img(
            src = "/background_circles.svg",
            attrs = Modifier.width(40.percent).minWidth(50.vw).height(autoLength)
                .filter(invert(if (Theme.isDark) 0 else 1))
                .align(Alignment.TopEnd).toAttrs()
        )

        Content(modifier = Modifier.align(Alignment.Center).margin(left = (-25).vw))

    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {

    Column(modifier = modifier) {
        SpanText(
            modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_CONDENSED).fontSize(32.bps()),
            text = "Hello I'm"
        )
        SpanText(
            modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                .fontSize(58.bps()),
            text = "Hossein Panahandeh."
        )
        SpanText(
            modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_CONDENSED).margin(top = 20.bps())
                .fontSize(24.px), text = "and nice to meet you!"
        )

        Button(
            modifier = ButtonStyle.toModifier().background(Theme.onBackgroundColor)
                .margin(top = 70.px),
            size = ButtonSize.SM,
            onClick = {
                window.open("https://drive.google.com/file/d/1QwGqhJ410NThDErkP1BuDtjrFBNGlMRK/view?usp=drive_link")
            }) {
            Box(
                modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center
            ) {
                SpanText(
                    text = "Resume",
                    modifier = Modifier.color(Theme.backgroundColor).fontFamily(Res.String.ROBOTO_REGULAR)
                        .fontSize(16.bps())
                )
            }
        }
    }

}